import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@material-ui/core';
import TabelaCandidatos from './TabelaCandidatos';

const useStyles = makeStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    '& > *': {
      color: theme.palette.common.white,
    }
  },
}));

export default function TabelaVagas(props) {
  const classes = useStyles();
  const vagas = props.vagas;

  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow className={classes.head}>
            <TableCell />
            <TableCell>Vaga</TableCell>
            <TableCell align="right">Candidatos</TableCell>
            <TableCell align="right">Tipo</TableCell>
            <TableCell align="right">Vigência</TableCell>
            <TableCell align="right">Qtd&nbsp;Vagas</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {vagas.map((vaga, index) => (
            <TabelaCandidatos key={index} vaga={vaga} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
